import { Stack, Box } from '@mui/material';
import { colors, IconButton } from '@sweep-io/sweep-design';
import { UniversalSearchInput } from './UniversalSearchInput';
import { UniversalSearchContent } from './UniversalSearchContent';
import { useUniversalSearchContext } from './UniversalSearchContext';
import { useObjectListUniversalSearch } from '../object-list/useObjectListUniversalSearch';
import { Close } from '@sweep-io/sweep-design/dist/icons/Close';
import { DialogLoader } from '../../common/dialogs/DialogLoader';

interface UniversalSearchProps {
  crmOrgId: string;
  isExpandedMode?: boolean;
}

export const UniversalSearch = ({ crmOrgId, isExpandedMode }: UniversalSearchProps) => {
  const { filterOptions, selectedFilterValue } = useUniversalSearchContext();

  const {
    searchTxt,
    tempSearchTxt,
    onSearchChange,
    onClearButtonClick,
    onSelectedFilterItem,
    isUniversalSearchListOpen,
    results,
    isLoadingResults,
    isLoadingDependency,
    onListItemClick,
    searchTypeOptions,
    selectedSearchType,
    onSelectSearchTypeOption,
    handleCloseUniversalSearch,
    onSearchKeydownWithEscHandler,
  } = useObjectListUniversalSearch({
    crmOrgId,
  });

  return (
    <Stack
      height="100%"
      ml={isExpandedMode ? '32px' : '0'}
      mr={isExpandedMode ? '32px' : '0'}
      border={isExpandedMode ? '1px solid' : 'none'}
      borderColor={isExpandedMode ? colors.grey[300] : 'transparent'}
      borderRadius={isExpandedMode ? '12px 12px 0 0' : '0'}
    >
      <DialogLoader visible={isLoadingDependency} />
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          height: '56px',
          backgroundColor: isExpandedMode ? colors.grey[100] : 'transparent',
          borderRadius: isExpandedMode ? '12px 12px 0 0' : '0',
          pr: isExpandedMode ? 1.5 : 0,
        }}
      >
        <Box sx={{ pl: isExpandedMode ? 1 : 0, width: '100%' }}>
          <UniversalSearchInput
            searchTxt={searchTxt}
            tempSearchTxt={tempSearchTxt}
            onKeyDown={onSearchKeydownWithEscHandler}
            onChange={onSearchChange}
            onClearButtonClick={onClearButtonClick}
            filterOptions={filterOptions}
            onSelectedFilterItem={onSelectedFilterItem}
            selectedFilterValue={selectedFilterValue}
            isUniversalSearchListOpen={isUniversalSearchListOpen}
            isExpandedMode={isExpandedMode}
            searchInputSize="default"
            menuOptions={searchTypeOptions}
            selectedMenuOption={selectedSearchType}
            onSelectMenuOption={onSelectSearchTypeOption}
          />
        </Box>
        {isExpandedMode && (
          <>
            <Box sx={{ flex: 1 }} />
            <IconButton variant="flat" size="small" onClick={handleCloseUniversalSearch}>
              <Close />
            </IconButton>
          </>
        )}
      </Box>

      <Box sx={{ flex: 1, overflow: 'hidden' }}>
        <UniversalSearchContent
          onListItemClick={onListItemClick}
          showLoader={false}
          results={results}
          isLoadingResults={isLoadingResults}
          crmOrgId={crmOrgId}
          filterOptions={filterOptions}
          onSelectedFilterItem={onSelectedFilterItem}
          selectedFilterValue={selectedFilterValue}
          isExpandedMode={isExpandedMode || false}
        />
      </Box>
    </Stack>
  );
};
